import { StatusBar } from 'react-native';
import { isAndroid, isWeb } from '@helpers';
import { useFocusEffect } from '@react-navigation/native';
import { useEffect, useState } from 'react';
import changeNavigationBarColor from 'react-native-navigation-bar-color';

// Cache to prevent unnecessary calls that cause flickering
let lastStatusBarColor = null;
let lastBarStyle = null;
let lastNavColor = null;

// Theme change counter to force updates
let themeChangeCounter = 0;
let themeChangeListeners = new Set();

// Function to clear cache when theme changes and notify all hooks
export const clearStatusBarCache = () => {
  lastStatusBarColor = null;
  lastBarStyle = null;
  lastNavColor = null;
  themeChangeCounter++;
  // Notify all active hooks to re-evaluate
  themeChangeListeners.forEach((listener) => listener());
};

export default (props) => {
  const {
    style = {},
    background,
    C: { scheme },
  } = props;

  const [themeVersion, setThemeVersion] = useState(themeChangeCounter);

  useEffect(() => {
    if (isWeb) return;
    const listener = () => setThemeVersion(themeChangeCounter);
    themeChangeListeners.add(listener);
    return () => themeChangeListeners.delete(listener);
  }, []);

  // Re-trigger when theme changes
  useEffect(() => {
    if (isWeb) return;
    trigerStatusBar();
  }, [themeVersion, scheme, background]);

  useFocusEffect(() => {
    if (isWeb) return;
    trigerStatusBar();
  });

  const trigerStatusBar = () => {
    switch (scheme) {
      case 'light':
        lightSchema(style.light);
        break;
      case 'dark':
        darkSchema(style.dark);
        break;
    }
    if (isAndroid) {
      const b = background ? background : scheme === 'light' ? 'white' : 'black';
      // Only set StatusBar color if it's different from last time
      if (b !== lastStatusBarColor) {
        StatusBar.setBackgroundColor(b);
        lastStatusBarColor = b;
      }

      const lightNav = '#F6F6F6';
      const darkNav = '#141414';
      const lightButtons = scheme === 'light';
      const navColor = scheme === 'light' ? lightNav : darkNav;

      // Only change navigation bar color if it's different from last time
      if (navColor !== lastNavColor) {
        changeNavigationBarColor(navColor, lightButtons);
        lastNavColor = navColor;
      }
    }
  };
  const darkSchema = (s) => {
    const style = s || 'light-content';
    if (style !== lastBarStyle) {
      StatusBar.setBarStyle(style);
      lastBarStyle = style;
    }
  };
  const lightSchema = (s) => {
    const style = s || 'dark-content';
    if (style !== lastBarStyle) {
      StatusBar.setBarStyle(style);
      lastBarStyle = style;
    }
  };
};
